import { Injectable } from "@angular/core";
import { CRMFieldConnector } from "./crm-field.connector";
import { AppServerCRMFieldConnector } from "../../app-server-connectors";
import { AuthenticationService, CachingService, IAMService, UIService } from "src/app/services/services.module";
import { FieldDocument, EntityType, FieldGroupDocument, FieldValidationError, APIResponse } from "server-model";

@Injectable()
export class CRMFieldDataService {
    private crmFieldConnector: CRMFieldConnector;

    constructor(
        private cachingService: CachingService,
        private iamService: IAMService,
        private authenticationService: AuthenticationService,
        private uiService: UIService,
    ) {
        this.crmFieldConnector = new AppServerCRMFieldConnector(this.iamService, this.authenticationService, this.uiService)
    }

    async getField(fieldName: string, organisationId: string, entityType: EntityType): Promise<APIResponse> {
        const response = await this.crmFieldConnector.getField(fieldName, organisationId, entityType);
        return response;
    }
    async createField(fieldDocument: FieldDocument): Promise<APIResponse> {
        const response = await this.crmFieldConnector.createField(fieldDocument);
        return response;
    }
    async updateField(fieldName: string, organisationId: string, entityType: EntityType, fieldDocument: FieldDocument): Promise<APIResponse> {
        const response = await this.crmFieldConnector.updateField(fieldName, organisationId, entityType, fieldDocument);
        return response;
    }
    async deleteField(fieldName: string, organisationId: string, entityType: EntityType): Promise<APIResponse> {
        const response = await this.crmFieldConnector.deleteField(fieldName, organisationId, entityType);
        return response;
    }
    async listFields(organisationId: string): Promise<APIResponse> {
        const response = await this.crmFieldConnector.listFields(organisationId);
        return response;
    }
    async getAllFieldsSpecificEntity(organisationId: string, entityType: EntityType): Promise<APIResponse> {
        const response = await this.crmFieldConnector.getAllFieldsSpecificEntity(organisationId, entityType);
        return response;
    }
    async getAllFieldsSpecificGroup(organisationId: string, entityType: EntityType, groupName: string): Promise<APIResponse> {
        const response = await this.crmFieldConnector.getAllFieldsSpecificGroup(organisationId, entityType, groupName);
        return response;
    }


    async getFieldGroup(groupName: string, organisationId: string): Promise<APIResponse> {
        const response = await this.crmFieldConnector.getFieldGroup(groupName, organisationId);
        return response;
    }
    async createFieldGroup(fieldGroupDocument: FieldGroupDocument): Promise<APIResponse> {
        const response = await this.crmFieldConnector.createFieldGroup(fieldGroupDocument);
        return response;
    }
    async updateFieldGroup(groupName: string, organisationId: string, fieldGroupDocument: FieldGroupDocument): Promise<APIResponse> {
        const response = await this.crmFieldConnector.updateFieldGroup(groupName, organisationId, fieldGroupDocument);
        return response;
    }
    async deleteFieldGroup(groupName: string, organisationId: string): Promise<APIResponse> {
        const response = await this.crmFieldConnector.deleteFieldGroup(groupName, organisationId);
        return response;
    }
    async listFieldGroups(organisationId: string): Promise<APIResponse> {
        const response = await this.crmFieldConnector.listFieldGroups(organisationId);
        return response;
    }


    async validateField(organisationId: string, entityType: EntityType, fields: { name: string; value: any }[]): Promise<APIResponse> {
        const response = await this.crmFieldConnector.validateField(organisationId, entityType, fields);
        return response;
    }
}
